var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM24.7102 14.2899L32.7102 22.2899C32.8039 22.3829 32.8783 22.4935 32.9291 22.6153C32.9798 22.7372 33.006 22.8679 33.006 22.9999C33.006 23.1319 32.9798 23.2626 32.9291 23.3845C32.8783 23.5063 32.8039 23.6169 32.7102 23.7099C32.6172 23.8036 32.5066 23.878 32.3848 23.9288C32.2629 23.9796 32.1322 24.0057 32.0002 24.0057C31.8682 24.0057 31.7375 23.9796 31.6156 23.9288C31.4937 23.878 31.3831 23.8036 31.2902 23.7099L25.0002 17.4099V32.9999C25.0002 33.2651 24.8948 33.5195 24.7073 33.707C24.5198 33.8945 24.2654 33.9999 24.0002 33.9999C23.735 33.9999 23.4806 33.8945 23.2931 33.707C23.1055 33.5195 23.0002 33.2651 23.0002 32.9999V17.4099L16.7102 23.7099C16.5219 23.8982 16.2665 24.004 16.0002 24.004C15.7339 24.004 15.4785 23.8982 15.2902 23.7099C15.1019 23.5216 14.9961 23.2662 14.9961 22.9999C14.9961 22.868 15.0221 22.7375 15.0725 22.6156C15.123 22.4938 15.1969 22.3831 15.2902 22.2899L23.2902 14.2899C23.3853 14.1989 23.4974 14.1275 23.6202 14.0799C23.8636 13.9799 24.1367 13.9799 24.3802 14.0799C24.5029 14.1275 24.6151 14.1989 24.7102 14.2899Z",
    fill: "#F0F1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.141 14.5869C31.3601 13.8057 30.0941 13.8057 29.3133 14.5869L27.3096 16.5917L31.4106 20.6949L33.4143 18.6901C34.1951 17.9089 34.1951 16.6422 33.4143 15.8609L32.141 14.5869ZM30.0313 22.0628L25.9302 17.9596L15.3858 28.5097C15.1295 28.766 14.9477 29.0873 14.8598 29.439L14.0312 32.7551C13.8482 33.4877 14.5114 34.1512 15.2436 33.9681L18.5579 33.1391C18.9095 33.0511 19.2305 32.8692 19.4868 32.6129L30.0313 22.0628Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateBtn);
export default __webpack_public_path__ + "static/media/updateBtn.20fe8833885b77bcef7520ddafec5a1a.svg";
export { ForwardRef as ReactComponent };